import {
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_CLICK_AND_SEAT,
  ORDER_TYPE_DELIVERY,
} from "../../constants";
import { getAddressFormatted, isObjectNotNull } from "../../utils";
import store from "../../redux/store";
import { ShopState } from "../../1_types/genericTypes";
import { isCustomerAddressDefined } from "../../utils/customer-address-and-shops";
import moment from "moment";
const generateDisplayAddress = (address, nbCaract = 25) =>
  `${getAddressFormatted(address).substring(0, nbCaract)}${address.length > nbCaract ? "..." : ""
  }`;

export const getAddress = (paramOrderType: string | null = null): string => {
  const state = store.getState();
  const { address: storeAddress, orderType: storeOrderType } = state.pendingOrderReducer;
  const { addressShop } = state.shopReducer as Partial<ShopState>;

  const orderType = paramOrderType ?? storeOrderType;
  const MAX_LENGTH = 100;
  const EMPTY_ADDRESS = "Aucune adresse";

  const isDelivery = orderType === ORDER_TYPE_DELIVERY;

  const selectedAddress = isDelivery
    ? storeAddress ?? addressShop
    : addressShop;

  const isValid = isDelivery
    ? isCustomerAddressDefined(selectedAddress)
    : isObjectNotNull(selectedAddress);

  return isValid
    ? generateDisplayAddress(selectedAddress, MAX_LENGTH)
    : EMPTY_ADDRESS;
};

export const getOrderTypeLabel = (orderType, isMobile) => {
  switch (orderType) {
    case ORDER_TYPE_DELIVERY:
      return !isMobile ? "Commande en Livraison" : "En Livraison";
    case ORDER_TYPE_CLICK_AND_COLLECT:
      return !isMobile ? "Commande à Emporter" : "À Emporter";
    case ORDER_TYPE_CLICK_AND_SEAT:
      return !isMobile ? "Commande sur Place" : "Sur Place";
    default:
      return "";
  }
};
export const getTodayOpeningStatus = (openHours, isClosedShop) => {
  if (!openHours) {
    return { text: "Horaires non disponibles", isOpen: false, lastSlot: null };
  }
  if (isClosedShop) {
    return { text: "Fermé", isOpen: false, lastSlot: null };
  }
  try {
    const now = moment();
    const todayKey = now.format("dddd").toLowerCase();

    let todayHours = null;

    Object.entries(openHours).forEach(([key, value]) => {
      if (key.toLowerCase() === todayKey) {
        todayHours = value;
      }
    });

    const slots = todayHours?.slots || [];

    if (!slots.length) {
      return { text: "Fermé aujourd'hui", isOpen: false, lastSlot: null };
    }

    const parsedSlots = slots
      .map((slot) => {
        const [start, end] = slot.split("-");
        return {
          start: moment(start, "HH:mm"),
          end: moment(end, "HH:mm"),
        };
      })
      .sort((a, b) => a.start.diff(b.start));


    let nextSlot = null;
    const lastSlot = parsedSlots[parsedSlots.length - 1];

    for (const slot of parsedSlots) {
      if (now.isBetween(slot.start, slot.end)) {
        return {
          text: `Ouvert jusqu'à ${slot.end.format("HH:mm")}`,
          isOpen: true,
          lastSlot: slot.end.format("HH:mm"),
        };
      }

      if (now.isBefore(slot.start) && !nextSlot) {
        nextSlot = slot;
      }
    }

    if (nextSlot) {
      return {
        text: `Fermé temporairement`,
        isOpen: false,
        lastSlot: lastSlot.end.format("HH:mm"),
      };
    }

    return {
      text: "Fermé aujourd'hui",
      isOpen: false,
      lastSlot: lastSlot.end.format("HH:mm"),
    };

  } catch (error) {
    console.error("Erreur lors de la récupération des horaires:", error);
    return { text: "Horaires non disponibles", isOpen: false, lastSlot: null };
  }
};
